module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//11.jpg?b8f49200511798ed85d77f59d1bbf3c7";